import { render } from "./otherServices.vue?vue&type=template&id=77e3a020"
import script from "./otherServices.vue?vue&type=script&lang=js"
export * from "./otherServices.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__